/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavedViewListResponse {
    getFixupPrototypeFunction() { return SavedViewListResponse.fixupPrototype; }

    static newInstance(model: Partial<SavedViewListResponse>): SavedViewListResponse {
        let obj = Object.assign(new SavedViewListResponse(), model);
        SavedViewListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavedViewListResponse>): SavedViewListResponse {
        if (!model) return null;
        return SavedViewListResponse.newInstance(<SavedViewListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavedViewListResponse) {
        if (!obj) return;

        models.SavedViewListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavedViewListResponse): boolean {
        Object.setPrototypeOf(obj, SavedViewListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.SavedViewDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<models.SavedViewDetail>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
